import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import SessionTimeOut from "./SessionTimeOut";

import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import store from "./store";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ToastContainer />
        <SessionTimeOut />
        <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route
                path="/"
                name="Status"
                render={(props) => <DefaultLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;
